import './index.css'
import { mount } from 'svelte'
import App from './App.svelte'
import { Buffer } from 'buffer'
import { endpoints } from './utils/helper.js'

window.endpoints = endpoints
globalThis.Buffer = Buffer

const app = mount(App, {
    target: document.getElementById('app'),
})

export default app
